export const AuthReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN_START':
      return {
        isFetching: true,
      };
    case 'LOGIN_END':
      return {
        isFetching: false,
      };
    case 'LOGIN':
      return {
        user: action.payload,
        isFetching: false,
      };
    case 'LOGOUT':
      return {
        user: {},
        isFetching: false,
      };
    case 'UPDATE_API_KEY':
      return {
        ...state,
        user: {
          ...state.user,
          company: {
            ...state.user.company,
            apiKey: action.payload,
          },
        },
      };
    default:
      state;
  }
};
